import React, { useState, useEffect } from 'react';
import { getMySubjects, uploadAssignment } from '../../api';
import { toast } from 'react-toastify';

const Assignments = () => {
  const [subjects, setSubjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    title: '', description: '', subject_id: '',
    due_date: '', total_marks: ''
  });

  useEffect(() => { loadSubjects(); }, []);

  const loadSubjects = async () => {
    try {
      const res = await getMySubjects();
      setSubjects(res.data);
    } catch (err) {
      toast.error('Error loading subjects');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      Object.keys(formData).forEach(k => data.append(k, formData[k]));
      if (file) data.append('file', file);
      await uploadAssignment(data);
      toast.success('Assignment uploaded!');
      setShowForm(false);
      setFormData({ title: '', description: '', subject_id: '', due_date: '', total_marks: '' });
      setFile(null);
    } catch (err) {
      toast.error('Error uploading assignment');
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>📝 Assignments</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + Upload Assignment
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>Upload New Assignment</h4>
          <form onSubmit={handleSubmit}>
            <div style={styles.formGrid}>
              <div>
                <label style={styles.label}>Title</label>
                <input style={styles.input} placeholder="Assignment title"
                  value={formData.title}
                  onChange={e => setFormData({...formData, title: e.target.value})} required />
              </div>
              <div>
                <label style={styles.label}>Subject</label>
                <select style={styles.input} value={formData.subject_id}
                  onChange={e => setFormData({...formData, subject_id: e.target.value})} required>
                  <option value="">Select Subject</option>
                  {subjects.map(s => (
                    <option key={s.id} value={s.id}>{s.name} - {s.class_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Due Date</label>
                <input style={styles.input} type="date"
                  value={formData.due_date}
                  onChange={e => setFormData({...formData, due_date: e.target.value})} />
              </div>
              <div>
                <label style={styles.label}>Total Marks</label>
                <input style={styles.input} type="number" placeholder="e.g. 20"
                  value={formData.total_marks}
                  onChange={e => setFormData({...formData, total_marks: e.target.value})} />
              </div>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Description</label>
              <textarea style={styles.textarea} placeholder="Assignment details..."
                value={formData.description} rows={3}
                onChange={e => setFormData({...formData, description: e.target.value})} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Upload File (Optional)</label>
              <input type="file" onChange={e => setFile(e.target.files[0])} />
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Upload</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.infoCard}>
        <p style={styles.infoText}>
          📌 Uploaded assignments will be visible to students in their portal.
          Students can view and download the assignment files.
        </p>
      </div>
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a6b3a', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a6b3a', margin: '0 0 15px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '15px', marginBottom: '15px' },
  inputGroup: { marginBottom: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  textarea: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', resize: 'vertical' },
  btnGroup: { display: 'flex', gap: '10px' },
  infoCard: { background: '#e8f5e9', borderRadius: '12px', padding: '20px' },
  infoText: { color: '#1a6b3a', margin: 0, fontSize: '14px' },
};

export default Assignments;